import { ablyChannelNamesForSession } from "_shared/_stores/realtime/ably-channel-names";
import reduxAblyMiddleware, { withCallbacks } from "_shared/_stores/realtime/redux-ably-middleware";
import { RootState } from "_shared/_stores/root-reducer";
import { AppDispatch } from "_shared/_stores/store-types";
import { assistantTurnStepReceived } from "ai-assistant/_stores/assistant-turn-progress-redux-slice";
import { AssistantTurnLiveStepZ } from "ai-assistant/turn-steps/assistant-turn-live-step-schema";

/** Matches `AblyAssistantTurnProgressChannel.EventName`. */
export const ASSISTANT_TURN_STEP_EVENT = "assistant-turn-step";

/**
 * A step that does not parse costs the panel one label and nothing else. Throwing, as the other
 * middlewares do for an entity they cannot read, would report a broken feed for what is only a
 * missing word; the turn's answer arrives in the reply either way.
 */
const handleTurnStep = (payload: unknown) => (dispatch: AppDispatch) => {
  const parsed = AssistantTurnLiveStepZ.safeParse(payload);
  if (!parsed.success) {
    console.warn("Ignored an assistant turn step that could not be read.");
    return;
  }

  dispatch(assistantTurnStepReceived(parsed.data));
};

const callbacks = withCallbacks<RootState, AppDispatch>().add(ASSISTANT_TURN_STEP_EVENT, handleTurnStep);

/**
 * What the user's own assistant turns are doing while they run (#7286).
 *
 * Attached for the whole session rather than per turn, so it is already listening when a turn
 * starts; a turn too short to need it costs nothing more.
 */
export const assistantTurnsAblyReduxMiddleware = reduxAblyMiddleware<RootState, AppDispatch>({
  callbacks,
  channelName: ablyChannelNamesForSession.assistantTurns,
  connectionHealth: { key: "assistantTurns", label: "Assistant" },
  shouldConnectionStartImmediately: true,
});
